import axios from "axios";

export function index(applicationId)
{
    return axios.get(route('api.manage.applications.interviews', {applicationId}) + '?include=user,companyLocation,subscriptions,subscriptions')
        .then(response => response.data);
}

let previousRequest = null;

export function allInterviews({extraParameters, page, all = false}) {
    if (typeof extraParameters == 'undefined') {
        extraParameters = {};
    }

    // set cancel token
    let cancelToken = axios.CancelToken.source();

    // cancel previous request
    if (previousRequest !== null) {
        previousRequest.cancel();
    }

    // reset previous request
    previousRequest = cancelToken;

    return axios.get(route('api.manage.companies.interviews.all') + '?include=application,user,subscriptions,invitation,timeslots.selectedInterview,selectedTimeslot,application.stage.job', {
        cancelToken: cancelToken.token,
        params: {
            ...extraParameters,
            page,
            fetch: (all ? 'all' : ''),
        }
    }).then((response) => {
        previousRequest = null;

        return response.data;
    });
}

export function show(interviewId)
{
    return axios.get(route('api.manage.interviews.show', {interviewId}) + '?include=user,interviewAnswers,subscriptions,invitation,timeslots.selectedInterview,selectedTimeslot')
        .then(({data}) => data);
}

export function destroy(interviewId) {
    return axios.delete(route('api.manage.interviews.destroy', {interviewId: interviewId}) + '?include=timelineEvents');
}

export function cancel(interviewId, data) {
    return axios.patch(route('api.manage.interviews.cancel', {interviewId: interviewId}) + '?include=timelineEvents', data);
}

export function create(applicationId, data) {
    //Create a single interview without invitation
    return axios.post(route('api.manage.applications.interviews', {applicationId}) + '?include=timelineEvents,interviewAnswers,invitation,subscriptions', data)
        .then(response => response.data);
}

export function createBulk(data, filters) {
    //Create multiple interviews
    filters = filters || {};

    return axios.post(
        route('api.manage.companies.interviews.store') + '?include=timelineEvents,interviewAnswers,invitation,subscriptions,timeslots',
        data,
        {params: {...filters}}
    )
        .then(response => response.data);
}

export function update(interviewId, data)
{
    return axios.patch(route('api.manage.interviews.update', {interviewId}) + '?include=timelineEvents,interviewAnswers,invitation,subscriptions,timeslots', data)
        .then(response => response.data);
}

export function confirmInvitation(interviewId, data)
{
    return axios.post(route('api.manage.interviews.confirmInvitation', {interviewId}), data)
        .then(({data}) => data)
}

export function createAnswer(interviewId, data)
{
    return axios.post(route('api.manage.interviews.answers.store', {interviewId}), data)
        .then(response => response.data);
}

export function updateAnswer(answerId, data)
{
    return axios.patch(route('api.manage.answers.update', {answerId}), data)
        .then(response => response.data);
}

export function deleteAnswer(answerId)
{
    return axios.delete(route('api.manage.answers.destroy', {answerId}));
}

export function types()
{
    return axios.get(route('api.manage.companies.interviews.types'))
        .then(({data}) => data);
}

export function bulkApplications(interviewId)
{
    return axios.get(route('api.manage.interviews.bulkApplications', {interviewId}))
        .then(({data}) => data);
}

export function reschedule(interviewId, data)
{
    return axios.patch(route('api.manage.interviews.reschedule', {interviewId}), data)
        .then(({data}) => data);
}

export function feedback(interviewId, data)
{
    return axios.patch(route('api.manage.interviews.feedback', {interviewId}), data)
        .then(({data}) => data);
}

export function statuses()
{
    return axios.get(route('api.manage.companies.interviews.statuses'))
        .then(({data}) => data);
}
